import React, { useState } from 'react';
import { Container, Nav, Navbar as BootstrapNavbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone } from 'react-icons/fa';
import logo from '../images/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="navbar-wrapper fixed-top">
      {/* Top Bar with Email, Logo, Phone */}
      <div className="top-contact-bar">
        <Container>
          <div className="d-flex justify-content-between align-items-center py-3">
            <div className="navbar-email">
              <FaEnvelope className="me-2" />
              <a href="mailto:info@aroghyaradham.com">info@aroghyaradham.com</a>
            </div>
            <div className="navbar-logo-center">
              <Link to="/">
                <img src={logo} alt="Aroghya Radham" className="center-logo" />
              </Link>
            </div>
            <div className="navbar-phone">
              <FaPhone className="me-2" />
              <a href="tel:+919281474570">+91 9281474570</a>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Navigation Menu */}
      <BootstrapNavbar expand="lg" className="main-navigation" expanded={expanded}>
        <Container className="d-flex align-items-center">
          <BootstrapNavbar.Brand as={Link} to="/" className="d-lg-none mobile-logo">
            <img src={logo} alt="Aroghya Radham" className="mobile-brand-logo" />
          </BootstrapNavbar.Brand>
          <BootstrapNavbar.Toggle 
            aria-controls="basic-navbar-nav" 
            onClick={() => setExpanded(!expanded)}
            className="ms-auto"
          />
          <BootstrapNavbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Home</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={() => setExpanded(false)}>About Us</Nav.Link>
              <Nav.Link as={Link} to="/core-services" onClick={() => setExpanded(false)}>Core Services</Nav.Link>
              <Nav.Link as={Link} to="/other-services" onClick={() => setExpanded(false)}>Other Services</Nav.Link>
              <Nav.Link as={Link} to="/teleconsultation" onClick={() => setExpanded(false)}>Teleconsultation</Nav.Link>
              <Nav.Link as={Link} to="/capacity-building" onClick={() => setExpanded(false)}>Capacity Building</Nav.Link>
              <Nav.Link as={Link} to="/job-vacancy" onClick={() => setExpanded(false)}>Job Vacancy</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact Us</Nav.Link>
            </Nav>
          </BootstrapNavbar.Collapse>
        </Container>
      </BootstrapNavbar>
    </div>
  );
};

export default Navbar;
